import styled from "styled-components"
import { Form } from '@unform/web';
import { Typography, Button } from '@material-ui/core';


export const ModalForm = styled(Form)`
    display:flex;
    flex-flow:column;

    .MuiFormControl-root {
        margin: 3px 0;
    }


    .MuiFormHelperText-root, .MuiFormHelperText-root.Mui-error{
        margin-top:0;
    }

    .MuiAccordion-root.Mui-disabled{
        background-color: rgb(255 255 255);

    }
    .MuiAccordionSummary-root.Mui-disabled{
        opacity:1;
    }

`

export const AccordionWrapper = styled.div`
    padding:10px 30px;
    
`
export const DateWrapper = styled.div`
    display:grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 5px;
    .MuiFormControl-root {
        margin: 10px 15px;
    }

    @media(max-width:640px){
        grid-template-columns: 1fr;
        grid-column-gap: 0px;
    }
`
export const DateContainer = styled.div`
    display:flex;
    flex-direction:column;
    .MuiFormControl-root{
        margin: 8px 0px;
    }
    .MuiFormHelperText-root.Mui-error{
        margin-bottom:2px;
    }
`

export const RadioWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;

    @media(max-width:396px){
        flex-flow:column;
    }
`
export const AccordionTitle = styled(Typography)`
    font-size: 1.2em;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87)
`




export const TransponderContainer = styled.div`
    display:flex;
   margin-bottom: 2px;
`

export const CleanButton = styled(Button)`
`

